// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__APnD0","title":"styles_title__Lp4A1"};